import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ServiceLogsViewerComponent } from './service-logs-viewer/service-logs-viewer.component';

const routes: Routes = [
    {
        path: 'serviceLogs',
        children: [
            { path: '', component: ServiceLogsViewerComponent }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ServiceLogsRoutingModule { }
